/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteFileInput = {|
  files?: ?$ReadOnlyArray<?string>,
  taskId?: ?string,
  projectId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deleteFileMutationModernMutationVariables = {|
  input: DeleteFileInput
|};
export type deleteFileMutationModernMutationResponse = {|
  +deleteFile: ?{|
    +deletedFileIds: ?$ReadOnlyArray<?string>
  |}
|};
export type deleteFileMutationModernMutation = {|
  variables: deleteFileMutationModernMutationVariables,
  response: deleteFileMutationModernMutationResponse,
|};
*/


/*
mutation deleteFileMutationModernMutation(
  $input: DeleteFileInput!
) {
  deleteFile(input: $input) {
    deletedFileIds
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteFileInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteFilePayload",
    "kind": "LinkedField",
    "name": "deleteFile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedFileIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteFileMutationModernMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteFileMutationModernMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteFileMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation deleteFileMutationModernMutation(\n  $input: DeleteFileInput!\n) {\n  deleteFile(input: $input) {\n    deletedFileIds\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8bb2b188b9c68923c33c3affbb914700';

module.exports = node;
